module.exports = __webpack_public_path__ + "img/logo.93e24c2c.png";